module.exports = __webpack_public_path__ + "static/media/icon_comet.6507e556.png";